import { render, staticRenderFns } from "./VModalTCloud.vue?vue&type=template&id=353a4e1a&"
import script from "./VModalTCloud.vue?vue&type=script&lang=ts&"
export * from "./VModalTCloud.vue?vue&type=script&lang=ts&"
import style0 from "./VModalTCloud.vue?vue&type=style&index=0&id=353a4e1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports